import { useTranslation } from 'react-i18next';

interface LoadingFallbackProps {
  message?: string;
  className?: string;
}

export const LoadingFallback = ({ message, className = "" }: LoadingFallbackProps) => {
  const { t } = useTranslation('common');
  
  return (
    <div className={`flex items-center justify-center ${className}`}>
      {message || t('common:loading')}
    </div>
  );
};